import React from 'react';
import { Flex } from '@televet/kibble-ui/build/chakra';
import { Icon } from '@televet/kibble-ui/build/components/Icon';

const MergeProfilesLockIcon = (): JSX.Element => {
  return (
    <Flex pt={0.5}>
      <Icon size="sm" name="lock" />
    </Flex>
  );
};

export default MergeProfilesLockIcon;
